import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Alert, CircularProgress } from '@mui/material';
import apiClient from '../config/axios';
import { useAuth } from '../contexts/AuthContext';

// Global ref to control FloatingAdmin from other components
export const floatingAdminRef = { current: null };

const FloatingAdmin = () => {
  const { user, refreshUser, login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [membershipId, setMembershipId] = useState('');

  // Set global ref for external access
  useEffect(() => {
    floatingAdminRef.current = {
      close: () => {} // No longer needed since it's in a menu
    };
    return () => {
      floatingAdminRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (user && Array.isArray(user.memberships) && user.memberships.length > 0) {
      const sorted = [...user.memberships].sort((a, b) => new Date(b.endDate) - new Date(a.endDate));
      setMembershipId(sorted[0].id);
    } else {
      setMembershipId('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleDelete = async () => {
    setLoading(true);
    setSuccess(null);
    setError(null);
    try {
      await apiClient.delete(`/api/dev/memberships/${membershipId}`);
      setSuccess('Membership cancellata con successo');
      setMembershipId('');
      await refreshUser();
    } catch (err) {
      setError(err.response?.data?.message || 'Errore nella cancellazione');
    } finally {
      setLoading(false);
    }
  };

  const handleQuickLogin = async (email, password) => {
    setLoading(true);
    setSuccess(null);
    setError(null);
    try {
      const result = await login(email, password);
      if (result.success) {
        setSuccess(`Login effettuato come ${email}`);
      } else {
        setError(result.error || 'Errore durante il login');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Errore durante il login');
    } finally {
      setLoading(false);
    }
  };

  // Add handler for deleting the first course
  const handleDeleteFirstEnrollment = async () => {
    if (!user || !Array.isArray(user.enrollments) || user.enrollments.length === 0) return;
    setLoading(true);
    setSuccess(null);
    setError(null);
    try {
      await apiClient.delete(`/api/dev/user-enrollment/${user.enrollments[0]._id}`);
      setSuccess(`Iscrizione eliminata con successo: ${user.enrollments[0].courseId}`);
      await refreshUser();
    } catch (err) {
      setError(err.response?.data?.message || 'Errore nella cancellazione dell\'iscrizione');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 1.5 }}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
          <CircularProgress size={16} />
        </Box>
      ) : (
        <>
          {/* Membership Section */}
          <Typography variant="caption" sx={{ mb: 0.5, fontWeight: 'bold', fontSize: '0.7rem' }}>
            Rimozioni rapide (DEMO ONLY)
          </Typography>
          {membershipId ? (
            <Button
              variant="contained"
              color="error"
              size="small"
              fullWidth
              disabled={loading}
              onClick={handleDelete}
              sx={{ mb: 1, py: 0.5, fontSize: '0.7rem' }}
            >
              Rimuovi Tesseramento
            </Button>
          ) : (
            <Alert severity="info" sx={{ mb: 1, py: 0.5, fontSize: '0.7rem' }}>Nessuna membership trovata</Alert>
          )}

          {/* Course Deletion Section */}
          {user && Array.isArray(user.enrollments) && user.enrollments.length > 0 && (
            <Button
              variant="contained"
              color="error"
              size="small"
              fullWidth
              disabled={loading}
              onClick={handleDeleteFirstEnrollment}
              sx={{ mb: 1, py: 0.5, fontSize: '0.7rem' }}
            >
              Rimuovi Iscrizione Corso
            </Button>
          )}

          {/* Quick Login Section */}
          <Typography variant="caption" sx={{ mb: 0.5, fontWeight: 'bold', fontSize: '0.7rem' }}>
            Quick Login (DEMO ONLY)
          </Typography>

          <Button
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            disabled={loading}
            onClick={() => handleQuickLogin('giggioz@gmail.com', 'xxxxxx')}
            sx={{ mb: 0.5, py: 0.5, fontSize: '0.7rem' }}
          >
            Log as Member
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            disabled={loading}
            onClick={() => handleQuickLogin('lucianagmoraes2@hotmail.com', 'xxxxxx')}
            sx={{ mb: 0.5, py: 0.5, fontSize: '0.7rem' }}
          >
            Log as Teacher
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            disabled={loading}
            onClick={() => handleQuickLogin('admin@dev.com', 'xxxxxx')}
            sx={{ mb: 0.5, py: 0.5, fontSize: '0.7rem' }}
          >
            Log as Admin
          </Button>
        </>
      )}
      {success && <Alert severity="success" sx={{ mt: 0.5, py: 0.5, fontSize: '0.7rem' }}>{success}</Alert>}
      {error && <Alert severity="error" sx={{ mt: 0.5, py: 0.5, fontSize: '0.7rem' }}>{error}</Alert>}
    </Box>
  );
};

export default FloatingAdmin; 